var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"dense":"","label":_vm.options.title,"clearable":""},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }